import React, { ReactElement, useCallback, useEffect } from 'react';
import Layout from './Layout';
import './team.less';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { publicBdmsSelector } from '~Public/selectors';
import { publicBdmsGetAction } from '~Public/actions';
import { Spinner } from 'react-bootstrap';
import IBdm from '~Api/Broker/IBdm';

export default function Team(): ReactElement {
    const bdms: IBdm[] = useSelector(publicBdmsSelector);

    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        if (!bdms) {
            dispatch(publicBdmsGetAction());
        }
    }, []);

    if (!bdms) {
        return (
            <Layout section='team'>
                <h1>Team</h1>
                <Spinner animation='border' />
            </Layout>
        );
    }

    const brokerTeamBlock: JSX.Element[] = (
        bdms.map((bdm: IBdm) => {
            let formattedPhone: string = null;
            if (bdm.phone) {
                formattedPhone = bdm.phone.replace(/\D/g, '');

                // Mobile (04xx xxx xxx)
                if (/^04\d{8}$/.test(formattedPhone)) {
                    formattedPhone = formattedPhone.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
                }

                // Landline (0X xxxx xxxx)
                if (/^0[2-8]\d{8}$/.test(formattedPhone)) {
                    formattedPhone = formattedPhone.replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3');
                }
            }

            return (
                <div className='member' key={bdm.name}>
                    {bdm.photoUrl ? <img src={bdm.photoUrl} /> : <img src=' https://www.funding.com.au/wp-content/uploads/2025/11/funding-icon.png' />}
                    <p className='name'>{bdm.name}</p>
                    <p className='title'>{bdm.title}</p>
                    {bdm.phone && <p className='phone'><a href={`tel:${(bdm.phone).replace(/\D/g, '')}`}>{formattedPhone}</a></p>}
                    <p className='email'><a href={`mailto:${bdm.email}`}>{bdm.email}</a></p>
                </div>
            );
        })
    );

    return (
        <Layout section='team'>
            <h1>Team</h1>
            <div className='team-main'>
                <div className='team-box'>
                    <h2>About Us</h2>
                    <p>Funding offers fast, simple Bridging, Business and Building loans secured by property. We are based in Brisbane and on the Gold Coast with dedicated Business Development Managers and direct access to our Credit Team.</p>
                    <p>Funding can lend for business and personal use, including NCCP and non-NCCP applications with loan terms up to 24 months. We offer quick quotes, online application lodgement and up to 1% commission with no clawbacks.</p>
                </div>
                <div className='team-box'>
                    <h2>Broker Team</h2>
                    <div className='members'>
                        {brokerTeamBlock}
                    </div>
                </div>
                <div className='team-box'>
                    <h2>Credit Team</h2>
                    <div className='members'>
                        <div className='member'>
                            <img src='https://www.funding.com.au/headshots/lauren-alexander/' />
                            <p className='name'>Lauren Alexander</p>
                            <p className='title'>Loans Officer</p>
                            <p className='phone'><a href='tel:0756466336'>07 5646 6336</a></p>
                            <p className='email'><a href='mailto:lauren@funding.com.au'>lauren@funding.com.au</a></p>
                        </div>
                        <div className='member'>
                            <img src='https://www.funding.com.au/headshots/john-bryant/' />
                            <p className='name'>John Bryant</p>
                            <p className='title'>Loans Officer</p>
                            <p className='phone'><a href='tel:0756463548'>07 5646 3548</a></p>
                            <p className='email'><a href='mailto:john@funding.com.au'>john@funding.com.au</a></p>
                        </div>
                    </div>
                </div>
                <div className='team-box'>
                    <h2>Broker Support Team</h2>
                    <div className='support-team'>
                        <p>Scenarios & Support <a href='tel:1300443319'>1300 44 33 19</a></p>
                        <p>Credit & Supporting Documents <a href='mailto:loanservices@funding.com.au'>loanservices@funding.com.au</a></p>
                        <p>Applications <a href='mailto:applications@funding.com.au'>applications@funding.com.au</a></p>
                        <p>Brokers & Accreditation <a href='mailto:broker@funding.com.au'>broker@funding.com.au</a></p>
                        <p>Weekdays 8.30am-5pm EST</p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
